import { render, staticRenderFns } from "./ScreenPrices.vue?vue&type=template&id=7fe04824&scoped=true"
import script from "./ScreenPrices.vue?vue&type=script&lang=js"
export * from "./ScreenPrices.vue?vue&type=script&lang=js"
import style0 from "./ScreenPrices.vue?vue&type=style&index=0&id=7fe04824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe04824",
  null
  
)

export default component.exports